import { Close, Select } from '@wix/wix-ui-icons-common/on-stage';
import { SectionNotification } from '@wix/wix-ui-tpa/cssVars';
import React, { useMemo } from 'react';
import { useTranslation } from '../../contexts/translation-context';
import styles from './field-answer-feedback.module.scss';
import { getAnswerFeedbackData } from './get-answers';
const SectionNotificationText = SectionNotification.Text;
export const FieldAnswerFeedbackWUT = props => {
  const {
    t
  } = useTranslation();
  const answer = useMemo(() => getAnswerFeedbackData(props.target, props.externalData), [props.target, props.externalData]);
  if (!answer || (answer == null ? void 0 : answer.correct) === undefined) {
    return null;
  }
  const fallbackText = answer.correct ? t('field.quiz-answer-feedback.correct') : t('field.quiz-answer-feedback.wrong');
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(SectionNotification, {
    size: "compact",
    type: answer.correct ? 'success' : 'error'
  }, /*#__PURE__*/React.createElement(SectionNotification.Icon, {
    icon: answer.correct ? /*#__PURE__*/React.createElement(Select, null) : /*#__PURE__*/React.createElement("div", {
      className: styles.iconWrapper
    }, /*#__PURE__*/React.createElement(Close, {
      size: 16
    }))
  }), /*#__PURE__*/React.createElement(SectionNotificationText, null, answer.message || fallbackText)));
};
//# sourceMappingURL=field-answer-feedback-wut.js.map